// extracted by mini-css-extract-plugin
export default {"messageButton":"style_messageButton__Env8a","messagesRestricted":"style_messagesRestricted__Pz0Ei"};